var Marionette = require('backbone.marionette');

module.exports = Marionette.Application.extend({
  initialize: function () {},
});
